import React from "react"
import Loader from "../../../../components/ui/loader"

interface AnimatedTextLoaderProps {
  text?: string
  color?: string
  fontSize?: string
}

const AnimatedTextLoader: React.FC<AnimatedTextLoaderProps> = ({
  text = "Loading your payment options...",
  color = "#4750F5",
  fontSize = "18px",
}) => {
  return (
    <div className="flex flex-col justify-center items-center h-[220px] space-y-4">
      <div className="flex gap-[2px]">
        {text.split("").map((char, i) => (
          <span
            key={i}
            className="animate-wave font-semibold"
            style={{
              animationDelay: `${i * 0.06}s`,
              color,
              fontSize,
            }}
          >
            {char === " " ? "\u00A0" : char}
          </span>
        ))}
      </div>

      <Loader />
    </div>
  )
}

export default AnimatedTextLoader
